"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Svgs = _interopRequireDefault(require("./Svgs"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icons = function Icons(props) {
  var name = props.name,
      className = props.className,
      classNameContainer = props.classNameContainer,
      disabled = props.disabled,
      type = props.type,
      typeStyle = props.typeStyle,
      color = props.color,
      onClick = props.onClick,
      isAction = props.isAction,
      rest = _objectWithoutProperties(props, ["name", "className", "classNameContainer", "disabled", "type", "typeStyle", "color", "onClick", "isAction"]);

  var iconClassName = (0, _classnames["default"])({
    "disabled": disabled === true,
    "actionIcon": isAction
  }, type, typeStyle, color, className);
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "icons-component ".concat(classNameContainer)
  }, rest, {
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(iconClassName)
  }, (0, _Svgs["default"])(name)));
};

Icons.propTypes = {
  name: _propTypes["default"].string,
  className: _propTypes["default"].string,
  classNameContainer: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["glyph", "framed-glyph", "framed-glyph-ext-1", "icon", "framed-icon", "framed-icon-ext-1", "framed-icon-ext-2", "micro-glyph-grape", "micro-glyph-teal"]),
  typeStyle: _propTypes["default"].oneOf(["", "off"]),
  color: _propTypes["default"].oneOf(["", "grape", "red", "silver"]),
  onClick: _propTypes["default"].func,
  isAction: _propTypes["default"].bool
};
Icons.defaultProps = {
  name: "",
  className: "",
  classNameContainer: "",
  disabled: false,
  type: "glyph",
  typeStyle: "",
  color: "",
  onClick: function onClick() {},
  isAction: false
};
var _default = Icons;
exports["default"] = _default;